import { createFeatureSelector, createSelector } from '@ngrx/store';

import { masterDataFeatureKey, MasterDataState } from './master-data.reducer';

export const selectMasterDataState = createFeatureSelector<MasterDataState>(masterDataFeatureKey);

export const selectMasterData = createSelector(selectMasterDataState, (state) => state.masterData);

export const selectMasterDataStatus = createSelector(
    selectMasterDataState,
    ({ masterData, loadFromServerProgress: { running, error } }) => {
        if (masterData) {
            return running ? 'refreshing' : 'ready';
        }

        if (running) return 'loading';

        if (error) return 'error';

        return 'missing';
    },
);

export const selectIsMasterDataLoaded = createSelector(selectMasterData, (masterData) => !!masterData);

export const selectDeviceProfileIfDefined = createSelector(selectMasterData, (masterData) => {
    return masterData?.deviceProfile?.name ? masterData?.deviceProfile : null;
});
